import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { LoginFormContentAbstract } from '../content/login-form-content.abstract';
import { NLoginFormModal } from './login-form-modal.interface';

@Directive()
export abstract class LoginFormModalAbstract extends LoginFormContentAbstract implements OnInit, OnDestroy {
    protected modalRef = inject(ModalRef<LoginFormModalAbstract>, { optional: true });
    protected modalData = inject<NLoginFormModal.IModalData>(MODAL_DATA, { optional: true });

    override ngOnInit(): void {
        super.ngOnInit();

        if (this.modalData?.email) {
            this.email = this.modalData?.email;
        }

        this.sendGtmEvent('openLoginpanel');
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();

        this.sendGtmEvent('closeLoginpanel');
    }

    get isCloseVariant(): boolean {
        return NLoginFormModal.EModalVariant.close === this.modalData?.variant;
    }

    get isModal(): boolean {
        return !!this.modalRef;
    }

    handleKeyUp(event?: KeyboardEvent) {
        if (event?.key === 'Enter') {
            this.emailInput?.nativeElement?.blur();

            this.submit();
        }

        if (this.form && this.form['submitAttempt'] && !this.email?.length) {
            this.form['submitAttempt'] = false;

            this.detectChanges();
        }
    }

    override check() {
        if (this.form) {
            this.form['submitAttempt'] = true;
            this.form.ngSubmit.emit();
        }

        this.detectChanges();

        super.check();
    }

    submit(): void {
        if (this.form?.valid) {
            if (this.shouldLogin()) {
                this.submitLogin();
            } else if (this.shouldRegister()) {
                this.submitRegister();
            }
        } else if (this.form) {
            this.form['submitAttempt'] = true;
            this.form.ngSubmit.emit();
        }
    }

    override close() {
        this.modalRef?.close();
    }

    protected override onSubmitSuccess() {
        super.onSubmitSuccess();

        if (this.isCloseVariant) {
            this.close();
        }
    }

    private sendGtmEvent(event: string): void {
        this.gtmService.push({ event });
    }

    protected override onEmailChange(newEmail: string | undefined, oldEmail: string | undefined): void {
        if (!newEmail?.length) {
            if (this.form) {
                this.form['submitAttempt'] = false;
                this.form.ngSubmit.emit();
            }

            this.detectChanges();
        }

        super.onEmailChange(newEmail, oldEmail);
    }

    override dataChangeHandle(newsletter: boolean): void {
        this.data.newsletter = newsletter;

        this.detectChanges();
    }
}
